namespace TabAurous.Retail {
    export interface POSOrderForm {
        TransDate: Serenity.DateEditor;
        TransId: Serenity.StringEditor;
        VoucherNo: Serenity.StringEditor;
        POSCustomerId: Serenity.ServiceLookupEditor;
        PartyId: Serenity.IntegerEditor;
        CustomerName: Serenity.StringEditor;
        Address: Serenity.TextAreaEditor;
        Mobile: Serenity.IntegerEditor;
        PanNumber: Serenity.StringEditor;
        BillNo: Serenity.StringEditor;
        BillDate: Serenity.DateEditor;
        ChallanNo: Serenity.StringEditor;
        ChallanDate: Serenity.DateEditor;
        BirthDate: Serenity.DateEditor;
        Anniversary: Serenity.DateEditor;
        CurrencyId: Serenity.LookupEditor;
        ExchRate: Serenity.DecimalEditor;
        EmployeeId: Serenity.IntegerEditor;
        UserId: Serenity.LookupEditor;
        MF: Serenity.DecimalEditor;
        ProductItemImage: Serenity.ImageUploadEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        ItemDetails: OrderItemsEditor;
        ReceiptDetails: ReceiptDetailsEditor;
        FinancialYearId: Serenity.IntegerEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        NetWeight: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        ReceiptAmount: Serenity.DecimalEditor;
        Discount: Serenity.DecimalEditor;
        AdditionalCharges: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        Remark: Serenity.TextAreaEditor;
        ShipAddressId: Serenity.IntegerEditor;
        CompanyId: Serenity.IntegerEditor;
        ShipmentId: Serenity.IntegerEditor;
    }

    export class POSOrderForm extends Serenity.PrefixedContext {
        static formKey = 'Retail.Order';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!POSOrderForm.init)  {
                POSOrderForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.StringEditor;
                var w2 = s.ServiceLookupEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.TextAreaEditor;
                var w5 = s.LookupEditor;
                var w6 = s.DecimalEditor;
                var w7 = s.ImageUploadEditor;
                var w8 = OrderItemsEditor;
                var w9 = ReceiptDetailsEditor;

                Q.initFormType(POSOrderForm, [
                    'TransDate', w0,
                    'TransId', w1,
                    'VoucherNo', w1,
                    'POSCustomerId', w2,
                    'PartyId', w3,
                    'CustomerName', w1,
                    'Address', w4,
                    'Mobile', w3,
                    'PanNumber', w1,
                    'BillNo', w1,
                    'BillDate', w0,
                    'ChallanNo', w1,
                    'ChallanDate', w0,
                    'BirthDate', w0,
                    'Anniversary', w0,
                    'CurrencyId', w5,
                    'ExchRate', w6,
                    'EmployeeId', w3,
                    'UserId', w5,
                    'MF', w6,
                    'ProductItemImage', w7,
                    'VoucherTypeId', w3,
                    'ItemDetails', w8,
                    'ReceiptDetails', w9,
                    'FinancialYearId', w3,
                    'Pieces', w3,
                    'Weight', w6,
                    'NetWeight', w6,
                    'NetAmount', w6,
                    'ReceiptAmount', w6,
                    'Discount', w6,
                    'AdditionalCharges', w6,
                    'GrossAmount', w6,
                    'Remark', w4,
                    'ShipAddressId', w3,
                    'CompanyId', w3,
                    'ShipmentId', w3
                ]);
            }
        }
    }
}
